import React from 'react';
import { useField } from 'react-final-form';
import { Select, OptionTypeBase } from '../../components';
import { useFieldProps } from '../useFieldProps';
import { SelectFieldProps } from './types';
import { fieldSubscription } from '../const';
import { FormGroup } from '../FormGroup';

export function SelectField<OptionType extends OptionTypeBase = any>(
  props: SelectFieldProps<OptionType>
): React.ReactElement {
  const {
    name,
    className,
    label,
    help,
    isClearable,
    validate,
    ...rest
  } = useFieldProps(props);
  const { input, meta } = useField<OptionType, any>(name, {
    subscription: fieldSubscription,
    validate,
  });

  const fieldProps = {
    ...input,
    error: meta.invalid && meta.touched,
    isClearable:
      typeof isClearable === 'undefined' ? !rest.required : isClearable,
    ...rest,
  };

  return (
    <FormGroup
      className={className}
      label={label}
      id={rest.id}
      help={help}
      meta={meta}
      required={fieldProps.required}
    >
      <Select {...fieldProps} />
    </FormGroup>
  );
}
